import React, { useEffect, useState } from 'react';
import styles from '../jesialves/jesialves.module.scss';
import perfil from '../jesialves/src/perfil.png';

type CupomCard = {
    id: number;
    image: string;
    brand: string;
    cupom?: string;
    site: string;
    modal: true;
};

type LinkCard = {
    id: number;
    image: string;
    link: string;
    modal?: false;
};

type CardItem = CupomCard | LinkCard;

const cardImages: CardItem[] = [
    {
        id: 1,
        image: require('./src/cards/1.png'),
        brand: 'Saint Germain',
        cupom: 'A-JESISGPA',
        site: 'https://www.saintgermainbrand.com.br/',
        modal: true,
    },
    {
        id: 2,
        image: require('./src/cards/2.png'),
        brand: 'Gocase',
        cupom: 'JESIANE',
        site: 'https://www.gocase.com.br/?utm_source=google&utm_medium=cpc&utm_campaign=_s_inst&utm_content=69267181666&utm_term=gocase&gad_source=1&gad_campaignid=952083588&gbraid=0AAAAADr5lVKb39BUD3gp2wRK31z1qFMP5&gclid=CjwKCAjwhZDUBhBGEiwAbi5bjvOeb8LehYKP1VAK66MSZxkGqoKIgU5nl9WrmGM9WDwo3Myj5PwiuxoChXcQAvD_BwE',
        modal: true,
    },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        brand: 'Riachuelo',
        cupom: 'JESIALVES',
        site: 'https://tidd.ly/4hGEuii',
        modal: true,
    },
    {
        id: 4,
        image: require('./src/cards/4.png'),
        brand: 'Clea Store',
        site: 'https://www.cleastore.com.br/',
        modal: true,
    },
    {
        id: 5,
        image: require('./src/cards/5.png'),
        link: 'https://br.shp.ee/czrphoos?fromSource=copy_link&smtt=0.0.9',
    },
];

const Jesialves: React.FC = () => {
    const [activeCard, setActiveCard] = useState<CupomCard | null>(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!activeCard) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setActiveCard(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [activeCard]);

    useEffect(() => {
        setCopied(false);
    }, [activeCard]);

    const handleCopy = async () => {
        if (!activeCard?.cupom) return;
        try {
            await navigator.clipboard.writeText(activeCard.cupom);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
        } catch {
            setCopied(false);
        }
    };

    return (
        <div className={styles.jesialves}>
            <div className={styles.container}>
                <img src={perfil} alt="Perfil" className={styles.perfil} />
                <div className={styles.cards}>
                    {cardImages.map((card) =>
                        card.modal ? (
                            <button
                                type="button"
                                key={card.id}
                                className={styles.card}
                                onClick={() => setActiveCard(card)}
                                aria-label={`Abrir cupom ${card.brand}`}
                            >
                                <img src={card.image} alt={card.brand} />
                            </button>
                        ) : (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={card.id}
                                className={styles.card}
                            >
                                <img src={card.image} alt={`Card ${card.id}`} />
                            </a>
                        )
                    )}
                </div>
            </div>

            {activeCard && (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setActiveCard(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="jesialves-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setActiveCard(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>

                        <p className={styles.modalEyebrow}>Cupom exclusivo</p>
                        <h2 id="jesialves-modal-title" className={styles.modalBrand}>
                            {activeCard.brand}
                        </h2>

                        {activeCard.cupom ? (
                            <div className={styles.cupomBox}>
                                <span className={styles.cupomLabel}>Seu cupom</span>
                                <span className={styles.cupomCode}>{activeCard.cupom}</span>
                                <button
                                    type="button"
                                    className={styles.copyBtn}
                                    onClick={handleCopy}
                                >
                                    {copied ? 'Copiado!' : 'Copiar cupom'}
                                </button>
                            </div>
                        ) : (
                            <div className={styles.cupomBoxEmpty}>
                                <span className={styles.cupomLabel}>Cupom</span>
                                <span className={styles.cupomEmptyText}>
                                    Em breve um cupom exclusivo para você
                                </span>
                            </div>
                        )}

                        <a
                            href={activeCard.site}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.siteBtn}
                        >
                            Ir para o site
                        </a>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Jesialves;
